import { render, staticRenderFns } from "./AdviceItem.vue?vue&type=template&id=325223e8&scoped=true&"
import script from "./AdviceItem.vue?vue&type=script&lang=js&"
export * from "./AdviceItem.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AdviceItem.vue?vue&type=style&index=0&id=325223e8&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "325223e8",
  "957718a2"
  
)

export default component.exports